export interface Dress {
  id: string;
  nameKey: string;
  thumbnail: string;
  unlocked: boolean;
  price: number;
  modelPath: string;
}

export const dressList: Dress[] = [
  { 
    id: 'default', 
    nameKey: 'dress.default', 
    thumbnail: '/assets/img/dress/thumb-default.png', 
    unlocked: true, 
    price: 0,
    modelPath: '/assets/live2d/sora-def-v015/sora.model3.json'
  },
  { 
    id: 'vest-v001', 
    nameKey: 'dress.vest', 
    thumbnail: '/assets/img/dress/thumb-vest.png', 
    unlocked: false, 
    price: 1,
    modelPath: '/assets/live2d/sora-vest-v002/sora.model3.json'
  },
  {
    id: 'loungewear-v001',
    nameKey: 'dress.loungewear',
    thumbnail: '/assets/img/dress/thumb-loungewear.png',
    unlocked: false,
    price: 1,
    modelPath: '/assets/live2d/sora-loungewear-v002/sora.model3.json'
  }
];

export const dressNames: Record<string, { ja: string; en: string }> = {
  'dress.default': { ja: 'デフォルト', en: 'Default' },
  'dress.vest': { ja: 'ベスト', en: 'Vest' },
  'dress.loungewear': { ja: 'ルームウェア', en: 'Loungewear' }
};